import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import Sidebar from './Sidebar';
import { changePassword } from '../utils/apiService';

const Changepassword = () => {
    const navigate = useNavigate();
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'

    const toggleCurrentPassword = () => {
        setShowCurrentPassword(!showCurrentPassword);
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setMessage('');
        setMessageType('');

        const formData = new FormData(e.target);
        const currentPassword = formData.get('current_password');
        const newPassword = formData.get('new_password');
        const confirmPassword = formData.get('new_password_confirmation');

        // Client-side validation
        if (newPassword !== confirmPassword) {
            setErrors({ confirmPassword: 'Passwords do not match!' });
            setMessage('Passwords do not match!');
            setMessageType('error');
            return;
        }

        if (newPassword.length < 8) {
            setErrors({ newPassword: 'Password must be at least 8 characters long.' });
            setMessage('Password must be at least 8 characters long.');
            setMessageType('error');
            return;
        }

        setLoading(true);

        try {
            const token = localStorage.getItem('token');

            if (!token) {
                navigate('/login');
                return;
            }

            const result = await changePassword({
                currentPassword,
                newPassword,
                confirmPassword
            }, token);

            if (result.status) {
                setMessage(result.message || 'Password changed successfully!');
                setMessageType('success');
                // Clear form
                e.target.reset();

                // Optionally redirect after success
                setTimeout(() => {
                    navigate('/dashboard');
                }, 2000);
            } else {
                setErrors(result.errors || {});
                setMessage(result.message || 'Failed to change password.');
                setMessageType('error');
            }
        } catch (error) {
            console.error('Error changing password:', error);
            setMessage('An error occurred. Please try again later.');
            setMessageType('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title split-text effect-right">
                            Change Password
                        </h1>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-team p-team tf-spacing-2">
                    <div className="tf-container">
                        <div className="row rg-30">
                            <div className="col-lg-4 col-md-4">
                                <Sidebar />
                            </div>

                            <div className="col-lg-8 col-md-8">
                                <div className="section-contact-inner flex justify-content-between flex-wrap login-form">
                                    <form
                                        id="changepasswordform"
                                        className="form-contact-us style-bg-dark-2 px-md-15"
                                        onSubmit={handleSubmit}
                                    >
                                        {/* Alert Message */}
                                        {message && (
                                            <div
                                                className={`mb-37 p-3 rounded`}
                                                style={{
                                                    backgroundColor: messageType === 'success' ? '#d4edda' : '#f8d7da',
                                                    color: messageType === 'success' ? '#155724' : '#721c24',
                                                    border: `1px solid ${messageType === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                                                    borderRadius: '5px'
                                                }}
                                            >
                                                {message}
                                            </div>
                                        )}

                                        {/* Current Password Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input
                                                        type={showCurrentPassword ? "text" : "password"}
                                                        name="current_password"
                                                        id="current_password"
                                                        placeholder="Current Password"
                                                        required
                                                        className={errors.current_password ? 'error-border' : ''}
                                                    />
                                                    <i
                                                        className={`toggle-password fa-regular ${showCurrentPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                        onClick={toggleCurrentPassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                </fieldset>
                                                {errors.current_password && (
                                                    <small className="text-danger mt-2 d-block" style={{ color: '#dc3545', fontSize: '0.875rem' }}>
                                                        {errors.current_password}
                                                    </small>
                                                )}
                                            </fieldset>
                                        </div>

                                        {/* New Password Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        name="new_password"
                                                        id="new_password"
                                                        placeholder="New Password"
                                                        required
                                                        className={errors.newPassword ? 'error-border' : ''}
                                                    />
                                                    <i
                                                        className={`toggle-password fa-regular ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                        onClick={togglePassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                </fieldset>
                                                {errors.newPassword && (
                                                    <small className="text-danger mt-2 d-block" style={{ color: '#dc3545', fontSize: '0.875rem' }}>
                                                        {errors.newPassword}
                                                    </small>
                                                )}
                                            </fieldset>
                                        </div>

                                        {/* Confirm Password Field */}
                                        <div className="cols mb-37 g-30">
                                            <fieldset className="item">
                                                <fieldset className="position-relative">
                                                    <input
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        name="new_password_confirmation"
                                                        id="new_password_confirmation"
                                                        placeholder="Confirm New Password"
                                                        required
                                                        className={errors.confirmPassword ? 'error-border' : ''}
                                                    />
                                                    <i
                                                        className={`toggle-confrim-password fa-regular ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                        onClick={toggleConfirmPassword}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                </fieldset>
                                                {errors.confirmPassword && (
                                                    <small className="text-danger mt-2 d-block" style={{ color: '#dc3545', fontSize: '0.875rem' }}>
                                                        {errors.confirmPassword}
                                                    </small>
                                                )}
                                            </fieldset>
                                        </div>

                                        <button
                                            type="submit"
                                            className="tf-btn style-bg-primary w-full justify-content-center"
                                            disabled={loading}
                                        >
                                            <span>{loading ? 'Changing...' : 'Change Password'}</span>
                                            {!loading && <i className="icon-arrow-right"></i>}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Changepassword;